var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 1400,
    viewBox: "0 0 80 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 1400,
    fill: "#242734"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2995_11024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 1400
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    width: 80,
    height: 1400,
    fill: "#242734"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2995_11024)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.55,
    cx: 78.7998,
    cy: 123.897,
    r: 250,
    fill: "url(#paint0_radial_2995_11024)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.55,
    cx: 130,
    cy: 852,
    r: 250,
    fill: "url(#paint1_radial_2995_11024)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.55,
    cx: -26,
    cy: 1207,
    r: 250,
    fill: "url(#paint2_linear_2995_11024)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    filter: "url(#filter0_b_2995_11024)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 1400,
    fill: "#242734"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2995_11024",
    x: -4,
    y: -4,
    width: 88,
    height: 1408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2995_11024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2995_11024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2995_11024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5205 123.146) rotate(57.1611) scale(224.279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2995_11024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.721 851.249) rotate(57.1611) scale(224.279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2995_11024",
    x1: -26,
    y1: 957,
    x2: 84,
    y2: 1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C2B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C2B0",
    stopOpacity: 0.68
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSidebar);
export default __webpack_public_path__ + "static/media/background-sidebar.1342560df950a87ceacdce5be528cb2d.svg";
export { ForwardRef as ReactComponent };